export default "/static/build/discover.png";